
import { FC, HTMLAttributes, ReactNode } from "react";
import SharedSorters from "src/components/SortersBar/Sorters";
import { SorterLabel } from "src/components/SortersBar/SorterButton";
import { computeFlightLabels, defaultRenderLabel } from "../utils";


const Sortersweb: FC<{
  dataGroups: Map<string, Map<number | string, any[]>>;
  sorters: any[];
  isLoading:boolean;
  activeSorter: string;
  activeValue?: boolean;
  renderLabel?: (label: SorterLabel | null) => ReactNode;
} & HTMLAttributes<HTMLDivElement>> = ({
  activeValue,
  ...props
}) => {
  return (
    <SharedSorters
      computeLabels={computeFlightLabels}
      renderLabel={defaultRenderLabel}
      {...props}
    />
  );
};

export default Sortersweb;
